import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import UserProfileSimple from "../molecules/UserProfileSimple";

const Select = ({ children, ...props }) => {
    let { name, id, disabled, value, style, colorType, onClick, onChange } = props;

    const onChangeHandelr = (e) => {
        if (onChange) {
            onChange(e);
        } else {
        }
    };
    return (
        <>
            <CustomSelet name={name} id={id ?? name} defaultValue={value} disabled={disabled} style={style} colorType={colorType} onChange={(e) => onChangeHandelr(e)} onClick={onClick}>
                {children}
            </CustomSelet>
        </>
    );
};

const CustomSelet = styled.select`
    padding: 5px;
    border: 1px solid var(--lightgray-color);
    border-radius: 5px;
    ${props => {
        switch (props.colorType) {
            case "1": return `background-color: var(--sub-color);`
            case "2": return `background-color: var(--highlight-color);`
            case "3": return `background-color: var(--main-dark-color); color: #fff;`
            case "4": return `background-color: var(--gray-color); color: #fff;`
            default: return `background-color: #ffffff;`
        }
    }}
`;

const SelectOption = ({ children, ...props }) => {
    let { selected, value, colorType } = props;

    return (
        <option selected={selected} value={value} colorType={colorType} key={value}>
            {children}
        </option>
    );
};

// Multi Select List
const SelectList = ({ children, ...props }) => {
    let { type, idx, disabled, data, preSelectedActiveList, value, stateValue, onChange } = props;

    const [activeList, setActiveList] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [listOpen, setListOpen] = useState(false);
    const wrapRef = useRef(null)
    const searchInputRef = useRef(null)

    useEffect(() => {
        setActiveList(preSelectedActiveList);
    }, [preSelectedActiveList]);

    useEffect(() => {
        setDataList(data);
    }, [data]);

    useEffect(() => {
        let reviewers = stateValue[0]?.reviewees[idx]?.reviewers;
        let tmp = [];

        if (reviewers?.length >= 0) {
            reviewers.forEach((el) => {
                tmp.push(el.idx);
            });

            setActiveList(tmp);
        }
    }, [stateValue, idx]);

    const filteredDataList = dataList.filter(item =>
        item.name?.toLowerCase().includes(searchTerm.toLowerCase())
    )

    // 리스트 박스를 열 때 검색창에 포커스
    useEffect(() => {
		if (listOpen && searchInputRef.current) {
			searchInputRef.current.focus()
		}
	}, [listOpen])

    // 컴포넌트 바깥 클릭 시 셀렉트 박스 닫도록
    useEffect(() => {
        const handleClickOutside = e => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setListOpen(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    const toggleListOpen = (e) => {
        e.stopPropagation()
        setListOpen(open => !open)
    }

    const selectListOptionClickHandler = (e, optionIdx) => {
        e.stopPropagation();
        const isActive = activeList.includes(optionIdx)
        onChange(e, idx, optionIdx);
        if (!isActive) setSearchTerm('')
        searchInputRef.current?.focus()
    };

    const selectBoxButtonClickHandler = (e, optionIdx) => {
        e.stopPropagation()
        onChange(e, idx, optionIdx);
        searchInputRef.current?.focus()
    };

    return (
        <>
            <CustomSelectListWrap ref={wrapRef}>
                <CustomSelectListBox onClick={toggleListOpen}>
                    <div>
                        {activeList &&
                            // dataList에 남아있는 목록만 렌더링 (리뷰이 지정 등으로 dataList가 바뀔 수 있음)
                            activeList.filter(elIdx => dataList.some(dataListEl => dataListEl.idx === elIdx)).map((el) => {
                                const item = dataList.find(d => d.idx === el)

                                return (
                                    <button key={item.idx} type="button" onClick={(e) => selectBoxButtonClickHandler(e, el)} data-idx={el}>
                                        <OptionItem>{item.name ?? ""} <i className="bi bi-x-circle-fill" /></OptionItem>
                                    </button>
                                );
                            })}
                    </div>

                    <button type="button" onClick={toggleListOpen}>
                        {listOpen === true ? "▲" : "▼"}
                    </button>
                </CustomSelectListBox>

                <CustomSelectList idx={idx} listopen={listOpen}>
                    <SearchInput type="text" placeholder="이름으로 검색" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} ref={searchInputRef} />
					{filteredDataList.map(item => (
						<SelectListOption
							key={item.idx}
							idx={item.idx}
							active={activeList.includes(item.idx) ? "true" : "false"}
							onClick={e => selectListOptionClickHandler(e, item.idx)}
						>
							<UserProfileSimple user={item} />
						</SelectListOption>
					))}
                </CustomSelectList>
            </CustomSelectListWrap>
        </>
    );
};

const CustomSelectListWrap = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
`;

const CustomSelectListBox = styled.div`
    display: flex;
    padding: 0px;
    border: 1px solid var(--lightgray-color);
    border-radius: 3px;
    padding: 5px;
    gap: 5px;
    cursor: pointer;

    div {
        display: flex;
        gap: 5px;
        flex-wrap: wrap;
        width: 100%;
        min-height: 30px;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;

        button {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            padding: 0px;
            background-color: #fff;
            border: 0px solid var(--gray-color);
            border-radius: 3px;
            height: 30px;
        }
    }

    & > button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        aspect-ratio: 1/1;
        background-color: var(--light-color);
        border: 0;
    }
`;

const CustomSelectList = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    gap: 5px;
    top: 100%;
    width: 100%;
    padding: 5px;
    background-color: #fff;
    border: 1px solid var(--gray-color);
    border-top: 0;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
    max-height: 500px;
    overflow-y: auto;
    z-index: 1;

    ${props => !props.listopen && `display: none;`}
    ${(props) => props.idx >= 0 && `z-index: ${99 - props.idx}`}
`;

const SearchInput = styled.input`
    position: sticky;
    top: 0;
	width: 100%;
	margin-bottom: 5px;
	border-radius: 3px;
    border: 1px solid var(--deep-light-color);
    z-index; 10;
`

const SelectListOption = ({ children, ...props }) => {
    let { type, disabled, idx, onClick, active } = props;

    return (
        <>
            <CustomSelectListOption type="button" disabled={disabled} data-idx={idx} onClick={onClick} active={active}>
                {children}
            </CustomSelectListOption>
        </>
    );
};

const CustomSelectListOption = styled.button`
    padding: 5px;
    background-color: #fff;
    border: 1px solid var(--lightgray-color);
    justify-content: flex-start;
    &:hover {
		box-shadow: inset 0 0 0 100px rgba(6,6,6,0.05);
	}

    ${(props) =>
        props.active === "true" &&
        `border-color: var(--gray-color);
        background: var(--highlight-light-color);`}
`;

const OptionItem = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 5px;
    font-weight: 400;
	padding: 5px 8px;
	background-color: var(--highlight-color);
	border: 1px solid var(--lightgray-color);
	border-radius: 3px;
	cursor: pointer;
	box-sizing: border-box;
	&:hover {
		background-color: var(--highlight-light-color);
	}
	i {
		color: #66555555;
		margin-top: -4px;
	}
`

export { Select, SelectOption, SelectList, SelectListOption };